export function formatAttendanceDuration(totalSeconds) {
    const s = Math.max(0, Math.floor(totalSeconds || 0));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (h > 0) {
        return `${h}h ${String(m).padStart(2, '0')}m`;
    }
    if (m > 0) {
        return `${m}m ${String(sec).padStart(2, '0')}s`;
    }
    return `${sec}s`;
}

export function flattenAttendanceForTimeline(summary) {
    const items = [];
    (summary?.users || []).forEach((user) => {
        (user.sessions || []).forEach((session) => {
            items.push({
                id: `attendance_${session.id}`,
                type: 'attendance',
                created_at: session.ended_at || session.started_at,
                user_name: user.user_name || `Usuário #${user.user_id}`,
                duration_seconds: session.duration_seconds,
                is_active: session.is_active,
                started_at: session.started_at,
                ended_at: session.ended_at,
            });
        });
    });
    return items;
}
